export function formatRelativeAnnotationTime(
  timestamp: number,
  referenceTime = Date.now(),
) {
  const relativeTimeFormat = new Intl.RelativeTimeFormat(undefined, {
    numeric: 'auto',
  });
  const elapsedMs = timestamp - referenceTime;
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;
  const weekMs = 7 * dayMs;

  if (Math.abs(elapsedMs) < hourMs) {
    return relativeTimeFormat.format(Math.round(elapsedMs / minuteMs), 'minute');
  }

  if (Math.abs(elapsedMs) < dayMs) {
    return relativeTimeFormat.format(Math.round(elapsedMs / hourMs), 'hour');
  }

  if (Math.abs(elapsedMs) < weekMs) {
    return relativeTimeFormat.format(Math.round(elapsedMs / dayMs), 'day');
  }

  return relativeTimeFormat.format(Math.round(elapsedMs / weekMs), 'week');
}
